module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0038.jpg?v=f9fe9ee6";